module.exports = __webpack_public_path__ + "img/icon_take_effect2.5feda374.png";